var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6837 3.3335L8.65039 9.3835",
    stroke: "#0195D3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3164 3.3335L31.3497 9.3835",
    stroke: "#0195D3",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 13.0858C3.33398 10.0024 4.98398 9.75244 7.03398 9.75244H32.9673C35.0173 9.75244 36.6673 10.0024 36.6673 13.0858C36.6673 16.6691 35.0173 16.4191 32.9673 16.4191H7.03398C4.98398 16.4191 3.33398 16.6691 3.33398 13.0858Z",
    stroke: "#0195D3",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2676 23.3335V29.2502",
    stroke: "#0195D3",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9336 23.3335V29.2502",
    stroke: "#0195D3",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83398 16.6665L8.18398 31.0665C8.71732 34.2998 10.0007 36.6665 14.7673 36.6665H24.8173C30.0007 36.6665 30.7673 34.3998 31.3673 31.2665L34.1673 16.6665",
    stroke: "#0195D3",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.2a99f22472db1b3115871c63645beac2.svg";
export { ForwardRef as ReactComponent };